import { render, staticRenderFns } from "./JobPreviewCompanyInfo.vue?vue&type=template&id=68eff621&scoped=true"
import script from "./JobPreviewCompanyInfo.vue?vue&type=script&lang=js"
export * from "./JobPreviewCompanyInfo.vue?vue&type=script&lang=js"
import style0 from "./JobPreviewCompanyInfo.vue?vue&type=style&index=0&id=68eff621&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68eff621",
  null
  
)

export default component.exports